<template>
  <div>
    <v-breadcrumbs :items="breadcrumbItems"/>

    <v-card  v-if="event">
      <Header :event="event"/>
      <v-card-title class="headline">{{ provider | titleize }} config for {{event.name}}</v-card-title>

      <v-card-text>      
        <p>
          Bring your own OAuth Client to your event. This allows you to have your own API limits and customize the description and icon during the connect flow.
        </p>

        <v-alert type="info" class="mt-8">This is a BETA feature. Feedback is welcome through our contact form :)</v-alert>
      </v-card-text>


      <v-card-text>
        <v-text-field v-model="model.client_id" label="Client ID" />
        <v-text-field v-model="model.client_secret" label="Client Secret" />
        <v-alert v-if="loadedClientId" type="warning">An existing app is already registered. Saving will overwrite current registration and might reset the secret!</v-alert>
        <v-btn color="primary" large @click="save">Save</v-btn>
      </v-card-text>
    </v-card>
  </div>      
</template>

<script>
import { mapGetters } from "vuex";
import eventManagerService from "@/services/eventManagerService";
import { EventBus } from '@/plugins/eventbus.js';
import firebase from 'firebase/app'
import 'firebase/auth'
import siteData from '@/data/site.json'
import Header from './_Header.vue'

export default {
  name: "OAuthClient",
  components: {
    Header,
  },
  props: {
  },
  data() {
    return {
      event: null,
      provider: null,
      model: {},
      loadedClientId: false,
      siteData: siteData,
    };
  },
  async mounted() {
    await this.getProfile();
    
    EventBus.$on('login-state-change', async user => {
      await this.getProfile();
    });
  },
  methods: {
    async getEvent(id, provider) {
      this.provider = provider;
      this.event = (await eventManagerService.get(id)).data;
      const client = (await eventManagerService.getOAuthClient(id, provider)).data || {};

      this.loadedClientId = client.client_id;
      this.model = { client_id: client.client_id };
      console.log('model', this.model);
    },

    async getProfile() {
      if (this.user) {
        await this.getEvent(this.$route.params.id, this.$route.params.provider);
      }
    },

    async save() {
      console.log('Saving', this.model);
      const response = (await eventManagerService.putOAuthClient(this.event.id, this.provider, this.model)).data;
      this.$helpers.toastResponse(this, response, 'Successfully saved client registration.');
      await this.getProfile();
    },

  },
  computed: {
    breadcrumbItems() {
      return !this.event || !this.provider ? [] : [
        { text: 'Event Manager', exact: true, to: { name: 'eventmanager' } },
        { text: this.event.name, exact: true, to: { name: 'eventmanagerView', params: {id: this.event.id}} },
        { text: `${this.provider} client registration`, disabled: true },
      ];
    },

    ...mapGetters({
      user: "user"
    })
  },
};
</script>
<style lang="scss">
.v-data-table.v-data-table--dense td { padding-top: 4px !important; padding-bottom:  4px !important;}
.v-input.v-input--hide-details { margin-top: 0 !important; }
</style>

